import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard';
import blueImage from '../images/blue.png';
import greyImage from '../images/grey.png';
import redImage from '../images/red.png';
import yellowImage from '../images/yellow.png';
import './browse.css';

const Browse: React.FC = () => {
  const navigate = useNavigate();

  const profiles = [
    { name: 'recruiter', image: blueImage },
    { name: 'developer', image: greyImage },
    { name: 'stalker', image: redImage },
    { name: 'adventurer', image: yellowImage },
  ];

  const handleProfileClick = (profile: { name: string; image: string }) => {
    navigate(`/profile/${profile.name}`, { state: { profileImage: profile.image } });
  };

  return (
    <div className="browse-container">
      <p className='who-is-watching'>Who's Watching?</p>
      <div className="profiles">
        {profiles.map((profile, index) => (
          <ProfileCard
            key={index}
            name={profile.name}
            image={profile.image}
            onClick={() => handleProfileClick(profile)}
          />
        ))}
      </div>
    </div>
  );
};

export default Browse;
